export default __webpack_public_path__ + "bf082d1bc2d7d59bbad18b63a4cd3aab.otf";